// ============================================================================
// CANCUN100 — HojaMenuMovil.js  (Bloque 14: menú ☰ del encabezado móvil)
// ----------------------------------------------------------------------------
// Hoja glass que SUBE desde abajo. Se cierra tocando fuera, deslizando hacia
// abajo, con "Cerrar" o con Escape. Va dentro del contenedor raíz (no en un
// portal) para heredar data-theme y los tokens --au-* de claro/oscuro.
// ============================================================================
import React, { useEffect, useRef, useState } from 'react';
import { RADIO, RADIO_TARJETA } from './tema';
import { Ic } from './iconos'; // APP 2/24

const BTN = {
  width: '100%', minHeight: 48, boxSizing: 'border-box', borderRadius: RADIO_TARJETA,
  fontSize: 14, fontWeight: 600, justifyContent: 'flex-start', padding: '0 16px', marginBottom: 10,
};

export default function HojaMenuMovil({ abierto, onCerrar, tasaTexto, onActualizar, onTasas, onSalir }) {
  const [dy, setDy] = useState(0);
  const [arrastrando, setArrastrando] = useState(false);
  const inicio = useRef(null);

  useEffect(() => {
    if (!abierto) return undefined;
    setDy(0);
    const esc = (e) => { if (e.key === 'Escape') onCerrar(); };
    window.addEventListener('keydown', esc);
    const antes = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', esc); document.body.style.overflow = antes; };
  }, [abierto, onCerrar]);

  if (!abierto) return null;

  const tocar = (e) => { inicio.current = e.touches[0].clientY; setArrastrando(true); };
  const mover = (e) => { if (inicio.current != null) setDy(Math.max(0, e.touches[0].clientY - inicio.current)); };
  const soltar = () => {
    inicio.current = null; setArrastrando(false);
    if (dy > 80) onCerrar(); else setDy(0);
  };
  const y = (fn) => () => { onCerrar(); fn(); };

  return (
    <div onClick={onCerrar}
      style={{ position: 'fixed', inset: 0, zIndex: 500, background: 'rgba(0,0,0,.55)', backdropFilter: 'blur(3px)', WebkitBackdropFilter: 'blur(3px)', animation: 'c100-aparece .2s ease-out' }}>
      <div role="dialog" aria-modal="true" aria-label="Menú" onClick={(e) => e.stopPropagation()}
        onTouchStart={tocar} onTouchMove={mover} onTouchEnd={soltar}
        style={{
          position: 'absolute', left: 0, right: 0, bottom: 0, maxHeight: '85vh', overflowY: 'auto', boxSizing: 'border-box',
          background: 'linear-gradient(var(--au-glass-fill-strong), var(--au-glass-fill-strong)), var(--au-bg-layer-2)',
          backdropFilter: 'blur(var(--au-glass-blur))', WebkitBackdropFilter: 'blur(var(--au-glass-blur))',
          border: '1px solid var(--au-glass-border)', borderBottom: 'none',
          borderRadius: `${RADIO_TARJETA}px ${RADIO_TARJETA}px 0 0`,
          boxShadow: 'var(--au-shadow-card)',
          padding: '10px 16px calc(16px + env(safe-area-inset-bottom))',
          transform: `translateY(${dy}px)`, transition: arrastrando ? 'none' : 'transform .2s ease',
          animation: 'c100-sube .24s ease-out', color: 'var(--au-text-primary)', fontFamily: 'var(--au-font-text)',
        }}>
        {/* asa */}
        <div aria-hidden="true" style={{ width: 42, height: 5, borderRadius: 3, background: 'var(--au-text-faint)', opacity: 0.6, margin: '2px auto 16px' }} />

        {/* 1. Tipo de cambio de hoy */}
        <div className="au-glass" style={{ borderRadius: RADIO_TARJETA, padding: '14px 16px', marginBottom: 12, boxShadow: 'none' }}>
          <div style={{ fontSize: 12, color: 'var(--au-text-faint)', letterSpacing: '.04em' }}>Tipo de cambio de hoy</div>
          <div className="au-num" style={{ fontSize: 22, fontWeight: 700, color: 'var(--au-blue-fg)', marginTop: 4 }}>USD {tasaTexto}</div>
        </div>

        {/* 2. Actualizar · 3. Tasas */}
        <button type="button" className="au-btn au-btn--secondary" style={BTN} onClick={y(onActualizar)}>
          <Ic n="RefreshCw" />Actualizar datos
        </button>
        {onTasas && (
          <button type="button" className="au-btn au-btn--secondary" style={BTN} onClick={y(onTasas)}>
            <Ic n="Banknote" />Tasas
          </button>
        )}

        {/* 4. (espacio para futuras opciones) */}
        <div style={{ height: 8 }} />

        {/* 5. Salir */}
        <button type="button" className="au-btn" onClick={y(onSalir)}
          style={{ ...BTN, justifyContent: 'center', background: 'transparent', border: '1px solid var(--au-error-fg)', color: 'var(--au-error-fg)' }}>
          Salir
        </button>
        <button type="button" className="au-btn au-btn--ghost" onClick={onCerrar}
          style={{ ...BTN, justifyContent: 'center', marginBottom: 0 }}>
          Cerrar
        </button>
      </div>
    </div>
  );
}

// Íconos del encabezado móvil (trazo con currentColor, 20 px).
const svg = (hijos) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{hijos}</svg>
);
export const ICONO_LUNA = svg(<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />);
export const ICONO_SOL = svg(<>
  <circle cx="12" cy="12" r="4.5" />
  <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
</>);
export const ICONO_MENU = svg(<path d="M4 7h16M4 12h16M4 17h16" />);
